<p-dialog
  header="{{ 'CONTACT.SCREEN.SCHEDULE_CONTACTS' | translate }}"
  [modal]="true"
  [(visible)]="isVisible"
  (onHide)="onDialogHide($event)"
  [dismissableMask]="true"
  [contentStyle]="{ overflow: 'visible' }"
  [focusOnShow]="false"
>
  <div class="container">
    @if (!isLoading) {
      <form #scheduleForm [formGroup]="scheduleFormGroup">
        <div class="start-time">
          <label for="startTime"
            >{{ 'CONTACT.LABEL.START' | translate }}:</label
          >
          <p-datepicker
            formControlName="startTime"
            [showTime]="true"
            hourFormat="24"
          />
        </div>
        @if (scheduleFormGroup.errors?.['start'] && scheduleFormGroup.dirty) {
          <div class="field-message">
            {{ 'CONTACT.VALIDATION.START_PASSED' | translate }}
          </div>
        }
        <div class="end-time">
          <label for="endTime">{{ 'CONTACT.LABEL.END' | translate }}:</label>
          <p-datepicker
            formControlName="endTime"
            [showTime]="true"
            hourFormat="24"
            [minDate]="minDateTime()"
          />
        </div>
        @if (scheduleFormGroup.errors?.['end']) {
          <div class="field-message">
            {{ 'CONTACT.VALIDATION.END_BEFORE_START' | translate }}
          </div>
        }
        <div class="time-zone dropdown ui-grid ui-grid-responsive ui-fluid">
          <label for="timeZone"
            >{{ 'LOCATION.LABEL.TIMEZONE' | translate }}:</label
          >
          <div>
            <p-select
              formControlName="scheduleTimeZone"
              optionLabel="label"
              [options]="timeZones"
              (onChange)="onTimeZoneChange($event)"
              appendTo="body"
              [style]="{ width: '100%' }"
            />
          </div>
        </div>
        <div class="primary dropdown ui-grid ui-grid-responsive ui-fluid">
          <label for="primary"
            >{{ 'CONTACT.LABEL.PRIMARY' | translate }}:</label
          >
          <div>
            <p-select
              [options]="contacts"
              formControlName="primary"
              (onChange)="onPrimaryContactChange($event)"
              placeholder="{{ 'CONTACT.LABEL.SELECT_PRIMARY' | translate }}"
              optionLabel="fullName"
              [showClear]="true"
              [style]="{ width: '100%' }"
            />
          </div>
        </div>
        <div class="secondary dropdown ui-grid ui-grid-responsive ui-fluid">
          <label for="secondary"
            >{{ 'CONTACT.LABEL.SECONDARY' | translate }}:</label
          >
          <div>
            <p-select
              [options]="contacts"
              formControlName="secondary"
              (onChange)="onSecondaryContactChange($event)"
              placeholder="{{ 'CONTACT.LABEL.SELECT_SECONDARY' | translate }}"
              optionLabel="fullName"
              [showClear]="true"
              [style]="{ width: '100%' }"
            />
          </div>
        </div>
        @if (saving) {
          <div>
            <app-progress-spinner [enabled]="saving" />
          </div>
        }
        @if (
          scheduleFormGroup.errors?.['required'] && scheduleFormGroup.dirty
        ) {
          <div class="field-message">
            {{ 'CONTACT.VALIDATION.CONTACT_REQUIRED' | translate }}
          </div>
        }
        @if (scheduleFormGroup.errors?.['match'] && scheduleFormGroup.dirty) {
          <div class="field-message">
            {{ 'CONTACT.VALIDATION.CONTACTS_MATCH' | translate }}
          </div>
        }
        <div class="button">
          <button
            pButton
            pRipple
            label="Delete"
            class="p-button-raised p-button-success"
            [disabled]="disableDelete"
            (click)="deleteContactListSchedule($event)"
          ></button>
          <button
            pButton
            pRipple
            label="Save"
            class="p-button-raised p-button-success right-align"
            [disabled]="!scheduleFormGroup.valid"
            (click)="onSubmit($event)"
          ></button>
        </div>
      </form>
    }
  </div>
</p-dialog>
